<template>
<div>

    <linkbutton toplabel="View Receipt" @click="getReceipt()"/>
  <!-- ACCT NOTE MODAL -->
      <modal ref="acctnoteModal">
        <template v-slot:header>
          <div class="receipttitlediv">
            <!-- <p class="receipttitle">Receipt for Transaction # {{transactionId}}</p> -->
          </div>
        </template>
        <template v-slot:body>
            <div id="receiptdatadiv">
                <div class="receipttitlediv">
                    <p class="receipttitle">Receipt for Transaction # {{transactionId}}</p>
                    <label class="receipttext">{{receiptText}}</label>
                </div>
                
            </div>
        </template>
        <template v-slot:footer>
          <div class="receipttitlediv">
                    <button ref="printthereceipt" class="printbutton"  v-print="'#receiptdatadiv'"  type="button">Print</button>
                    <smallbutton  @click="$refs.acctnoteModal.closeModal()" toplabel="Close"/>
                </div>
        <!--   <div class="closeButton">
            
          </div> -->
          <div>
              <label class="responsemessage">{{message}}</label>
            </div>
        </template>
      </modal>
    </div>
</template>

<script>
import datamethods from '../../datamethods.js'
import smallbutton from '../controls/button.vue'
import modal from '../controls/modal.vue'
import linkbutton from '../controls/linkbutton.vue'

export default {
    name:'transreceipt',
    components:{
        smallbutton,
        modal,
        linkbutton
    },
    props:{
        transactionId:{
            type:Number,
            required:true
        }
        
    },
    mixins:[datamethods],
    data(){
        return{
            message:'',
            receiptText:''
        }
    },
    methods:{
        async getReceipt(){
            
            this.message=''
            let req = {
                transactionId:this.transactionId
            }
            console.log('re ' + this.transactionId)
            var response = await this.callAPI(req,'receipt')

            if(response.Successful){
                this.receiptText=response.StringResponse
                this.$refs.acctnoteModal.openModal()
            }else{
                this.message = response.Message
            }
            
        },
        
    }
}
</script>


<style>
.closeButton{
    display:flex;
    flex-direction: row-reverse;
}
.receipttext{
    font-size:medium;
    white-space:pre-wrap;
    text-align: center;
}
.receipttitle{
    font-size:large;
    text-align: center;
}
.receipttitlediv{
    text-align:center;
}
.printbutton{
    
 
    color:var(--light-text-color);
    border: none;
    border-radius:10px;
    width:130px;
    height:50px;
    padding:0px;
    font-size: medium;
    margin:10px;
  text-decoration: none;
background-color:var(--button-color);
}
button:hover{
    background-color:var(--highlight-button-color);
  cursor:pointer;
}
button:disabled{
  background-color:gray;
}


</style>